import Quill from 'quill';

class SourceCodeButton {
  private quill: Quill;
  private button: HTMLButtonElement;
  private popup: HTMLDivElement;

  constructor(quill: Quill) {
    this.quill = quill;

    const toolbar = quill.getModule('toolbar') as any;
    if (!toolbar) {
      throw new Error('SourceCodeButton requires the "toolbar" module.');
    }
    const buttonContainer = document.createElement('span');
    buttonContainer.classList.add('ql-formats');

    this.button = document.createElement('button');
    this.button.innerHTML = `<svg class="" viewBox="0 0 20 20">
              <path d="m12.5 0 5 4.5v15.003h-16V0h11zM3 1.5v3.25l-1.497 1-.003 8 1.5 1v3.254L7.685 18l-.001 1.504H17.5V8.002L16 9.428l-.004-4.22-4.222-3.692L3 1.5z"></path>
              <path d="M4.06 6.64a.75.75 0 0 1 .958 1.15l-.085.07L2.29 9.75l2.646 1.89c.302.216.4.62.232.951l-.058.095a.75.75 0 0 1-.951.232l-.095-.058-3.5-2.5V9.14l3.496-2.5zm4.194 6.22a.75.75 0 0 1-.958-1.149l.085-.07 2.643-1.89-2.646-1.89a.75.75 0 0 1-.232-.952l.058-.095a.75.75 0 0 1 .95-.232l.096.058 3.5 2.5v1.22l-3.496 2.5zm7.644-.836 2.122 2.122-5.825 5.809-2.125-.005.003-2.116zm2.539-1.847 1.414 1.414a.5.5 0 0 1 0 .707l-1.06 1.06-2.122-2.12 1.061-1.061a.5.5 0 0 1 .707 0z"></path>
            </svg>`; // Source code icon
    this.button.title = 'Edit HTML';
    this.button.type = 'button';
    this.button.classList.add('ql-source-code');

    buttonContainer.appendChild(this.button);
    toolbar.container.appendChild(buttonContainer);

    this.button.addEventListener('click', () => this.showPopup(this.button));

    this.createPopup();
  }

  createPopup() {
    this.popup = document.createElement('div');
    this.popup.classList.add('ql-source-code-popup');

    const textarea = document.createElement('textarea');
    textarea.classList.add('ql-source-code-textarea');

    textarea.addEventListener('input', () => this.updateQuillContent(textarea));

    const buttonContainer = document.createElement('div');
    buttonContainer.classList.add('ql-source-code-buttons');

    const closeButton = document.createElement('button');
    closeButton.innerText = 'Close';
    closeButton.type = 'button';
    closeButton.style.border = '1px solid';
    closeButton.addEventListener('click', () => this.closePopup());

    buttonContainer.appendChild(closeButton);

    this.popup.appendChild(textarea);
    this.popup.appendChild(buttonContainer);

    this.quill.container.parentElement.appendChild(this.popup);
  }

  showPopup(button: HTMLButtonElement) {
    const editorContent =  this.quill.getText() === '' ? '' : this.quill.getSemanticHTML();
    const textarea = this.popup.querySelector('.ql-source-code-textarea') as HTMLTextAreaElement;
    textarea.value = formatHtml(editorContent);
    this.popup.classList.add('ql-source-code-show');
  }

  saveHtml(html: string) {
    this.quill.clipboard.dangerouslyPasteHTML(html);
    this.closePopup();
  }

  closePopup() {
    this.popup.classList.remove('ql-source-code-show');
  }

  updateQuillContent(textarea: HTMLTextAreaElement) {
    const cursorPosition = textarea.selectionStart;
    this.quill.clipboard.dangerouslyPasteHTML(textarea.value);
    textarea.focus();
    textarea.setSelectionRange(cursorPosition, cursorPosition); // Restore cursor position
  }
}

export default SourceCodeButton;

export function formatHtml(html: string): string {
  const onlyParagraphTagsPattern = /^(\s*<p>\s*<\/p>\s*)+$/;
  if (onlyParagraphTagsPattern.test(html)) {
    return '';
  }
  return html
    .replace(/<p style="padding-left: 3em;">/g, '<p>') // Remove indentation without ql-class styles
    .replace(/href="(.*?)"/g, match => match.replace(/\s/g, '')); // Remove spaces within href
}
